"use client"
import { ComponentConfig } from "@measured/puck"
import { MediaSelect } from "../../../../media/pages/SelectMediaUIBuilder"
import { commonStylesProps } from "../../lib/commonCSSProps"
import getClassNameFactory from "../../lib/get-class-name-factory"
import { ImageProps, RenderConfig } from "./RenderConfig"
import styles from "./styles.module.css"

const getClassName = getClassNameFactory("Image", styles)

export const Image: ComponentConfig<ImageProps> = {
  label: "Image",
  //@ts-ignore
  fields: {
    imageUrl: {
      label: "Image",
      type: "custom",
      render: props => <MediaSelect {...props} />,
    },
    link: {
      label: "Link",
      type: "text",
    },
    showCaption: {
      label: "Show Caption",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    heightMobile: { label: "Height on Mobile", type: "text" },
    heightTablet: { label: "Height on Tablet", type: "text" },
    heightStyle: { label: "Height on Desktop", type: "text" },
    witdhMobile: { label: "Width on Mobile", type: "text" },
    widthTablet: { label: "Width on Tablet", type: "text" },
    widthDesktop: { label: "Width on Desktop", type: "text" },
    borderRadius: { label: "Border Radius", type: "text" },
    padding: { label: "Padding", type: "text" },
    margin: { label: "Margin", type: "text" },
    border: { label: "Border", type: "text" },
    multiple: {
      label: "Multiple",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    objectFit: {
      label: "Object Fit",
      type: "select",
      options: [
        {
          label: "Cover",
          value: "cover",
        },
        {
          label: "Contain",
          value: "contain",
        },
        {
          label: "Fill",
          value: "fill",
        },
        {
          label: "None",
          value: "none",
        },
        {
          label: "Scale Down",
          value: "scale-down",
        },
      ],
    },
    objectPosition: {
      label: "Object Position",
      type: "select",
      options: [
        { label: "Center", value: "center" },
        { label: "Top", value: "top" },
        { label: "Bottom", value: "bottom" },
        { label: "Left", value: "left" },
        { label: "Right", value: "right" },
        { label: "Top Left", value: "top-left" },
        { label: "Top Right", value: "top-right" },
        { label: "Bottom Left", value: "bottom-left" },
        { label: "Bottom Right", value: "bottom-right" },
      ],
    },

    ...commonStylesProps, // Include common CSS props
  },
  defaultProps: {
    padding: "0px",
    heightStyle: "auto",
    witdhMobile: "100%",
    borderRadius: "0px",
    border: "0px",
    multiple: false,
    objectFit: "cover",
    objectPosition: "center",
    className: "",
    showCaption: false,
  },
  ...RenderConfig,
}
